import { DOMAIN } from "../utilities/consts";
class TempApi {
  static getFakeData() {
    return fetch(`/fakedata/temp.json`)
      .then(response => response.json())
      .then(data => data);
  }

  static getData(config) {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/ObtenerDatosTemp`, {
      //mode: "cors",
      method: "POST",
      body: JSON.stringify(config),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  }

  static getRanges(unidades) {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/ObtenerRangosTemperatura`, {
      method: "POST",
      body: JSON.stringify({
        unidades
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  }

  static getFakeRanges() {
    return fetch(`/fakedata/tempRanges.json`)
      .then(response => response.json())
      .then(data => data);
  }

  static saveRanges(config) {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/GuardarNuevoRangoTemperatura`, {
      //mode: "cors",
      method: "POST",
      body: JSON.stringify(config),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  }

  static saveRangesFake(config) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let response = config.rangos.map(r => ({
          ...r,
          Fecha: new Date().toISOString()
        }));
        resolve(response);
      }, 1000);
    });
  }
}

export default TempApi;



// WEBPACK FOOTER //
// ./src/api/temp.js